export enum ActiveView {
  INVITE_CANDIDATES = 'inviteCandidates',
  IN_CONVERSATION = 'inConversation',
  IN_SHORTLIST = 'inShortlist',
  PENDING_INVITES = 'pendingInvites',
}
